export default "__VITE_ASSET__B0TtiuE4__"